import { useContext, useState } from 'react'
import { StoreContext } from '~/store'
import { updateMarketingConsent } from '~/lib/api'
import { useTranslation } from 'react-i18next'
import { Modal, FormContent, FormHeader, ButtonDrawer } from '~/components'
import * as styles from './index.module.css'

export default function MarketingConsentModal() {
  const { t } = useTranslation()
  const { user, setUser } = useContext(StoreContext)
  const [isLoading, setIsLoading] = useState(false)

  if (!user?.shouldConsentToMarketing) return null

  const handleConsent = (consent) => {
    setIsLoading(true)
    updateMarketingConsent(user.userId, consent)
      .then(response => setUser(response))
      .catch(() => setUser({ ...user, shouldConsentToMarketing: false }))
      .finally(() => setIsLoading(false))
  }

  const buttons = [
    { func: () => handleConsent(false), title: t('marketing-consent-no'), isLoading },
    { func: () => handleConsent(true), title: t('marketing-consent-yes'), isLoading },
  ]

  return (
    <Modal isOpen rounded>
      <FormContent isLoading={isLoading}>
        <FormHeader>{t('marketing-consent-title')}</FormHeader>
        <p className={styles.body}>{t('marketing-consent-body')}</p>
      </FormContent>
      <ButtonDrawer buttons={buttons} isLoading={isLoading} modal />
    </Modal>
  )
}
